export const planDataMapper = (data) => ({
  planHeading: data?.description,
  planValidity: `${data?.validity} ${data?.validityUnit}`,
  planBenifit: `${Math.round(data?.data)} ${data?.dataUnit}`,
  planPrice: `${data?.currency} ${data?.amount?.toLocaleString()}`,
  ...data
})
